msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fa\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2025-03-08 01:54\n"
"Last-Translator: \n"
"Language-Team: Persian\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: fa\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:136
msgid "Locked"
msgstr "قفل شده"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:142
msgid "Posts: {0}"
msgstr "فرسته‌ها: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:147
msgid "Last posted: {0}"
msgstr "آخرین فرسته‌ها: {0}"

#: src/components/account-block.jsx:162
#: src/components/account-info.jsx:659
msgid "Automated"
msgstr "خودکارشده"

#: src/components/account-block.jsx:169
#: src/components/account-info.jsx:664
#: src/components/status.jsx:547
msgid "Group"
msgstr "گروه"

#: src/components/account-block.jsx:179
msgid "Mutual"
msgstr "متقابل"

#: src/components/account-block.jsx:183
#: src/components/account-info.jsx:1705
msgid "Requested"
msgstr "درخواست‌شده"

#: src/components/account-block.jsx:187
#: src/components/account-info.jsx:1696
msgid "Following"
msgstr "پی‌گرفته"

#: src/components/account-block.jsx:191
#: src/components/account-info.jsx:1087
msgid "Follows you"
msgstr "شما را پی میگیرد"

#: src/components/account-block.jsx:199
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural,one {# پی‌گرفته} other {# پی‌گرفته‌ها}}"

#: src/components/account-block.jsx:208
#: src/components/account-info.jsx:705
msgid "Verified"
msgstr "تاییدشده"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:223
#: src/components/account-info.jsx:805
msgid "Joined <0>{0}</0>"
msgstr "عضو شده<0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "برای همیشه"

#: src/components/account-info.jsx:378
msgid "Unable to load account."
msgstr "ناتوان در بارگذاری حساب کاربری."

#: src/components/account-info.jsx:387
msgid "Go to account page"
msgstr "برو به صفحهٔ حساب کاربری"

#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:727
#: src/components/account-info.jsx:757
msgid "Followers"
msgstr "پی‌گیرنده"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:767
#: src/components/account-info.jsx:784
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:422
#: src/components/account-info.jsx:801
#: src/pages/account-statuses.jsx:479
#: src/pages/search.jsx:328
#: src/pages/search.jsx:475
msgid "Posts"
msgstr "فرسته"

#: src/components/account-info.jsx:430
#: src/components/account-info.jsx:1143
#: src/components/compose.jsx:2772
#: src/components/media-alt-modal.jsx:46
#: src/components/media-modal.jsx:358
#: src/components/status.jsx:1770
#: src/components/status.jsx:1787
#: src/components/status.jsx:1912
#: src/components/status.jsx:2517
#: src/components/status.jsx:2520
#: src/pages/account-statuses.jsx:523
#: src/pages/accounts.jsx:110
#: src/pages/hashtag.jsx:200
#: src/pages/list.jsx:158
#: src/pages/public.jsx:115
#: src/pages/scheduled-posts.jsx:87
#: src/pages/status.jsx:1214
#: src/pages/trending.jsx:472
msgid "More"
msgstr "بیشتر"

#: src/components/account-info.jsx:442
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr ""

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1301
msgid "Handle copied"
msgstr ""

#: src/components/account-info.jsx:590
#: src/components/account-info.jsx:1304
msgid "Unable to copy handle"
msgstr ""

#: src/components/account-info.jsx:596
#: src/components/account-info.jsx:1310
msgid "Copy handle"
msgstr ""

#: src/components/account-info.jsx:602
msgid "Go to original profile page"
msgstr "برو به صفحهٔ اصلی نمایه"

#: src/components/account-info.jsx:620
msgid "View profile image"
msgstr "نمایش تصویر نمایه"

#: src/components/account-info.jsx:637
msgid "View profile header"
msgstr "نمایش سرآیند نمایه"

#: src/components/account-info.jsx:654
msgid "In Memoriam"
msgstr "در یادبود"

#: src/components/account-info.jsx:734
#: src/components/account-info.jsx:775
msgid "This user has chosen to not make this information available."
msgstr "این کاربر انتخاب کرده که این اطلاعات در دسترس نباشد."

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:830
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} فرسته‌های اصلی، {1} پاسخ‌ها، {2} تقویت‌ها"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:846
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {۱ فرستهٔ آخر در ۱ روز گذشته} other {۱ فرستهٔ آخر در {2} روز گذشته}}} other {{3, plural, one {{4} فرستهٔ آخر در ۱ روز گذشته} other {{5} فرستهٔ آخر در {6} روز گذشته}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:859
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {۱ فرستهٔ آخر در سال گذشته} other {{1} فرستهٔ آخر در سال گذشته}}"

#: src/components/account-info.jsx:883
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "اصلی"

#: src/components/account-info.jsx:887
#: src/components/status.jsx:2303
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2058
#: src/pages/status.jsx:937
#: src/pages/status.jsx:1560
msgid "Replies"
msgstr "پاسخ‌ها"

#: src/components/account-info.jsx:891
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2070
#: src/pages/settings.jsx:1151
msgid "Boosts"
msgstr "تقویت‌ها"

#: src/components/account-info.jsx:897
msgid "Post stats unavailable."
msgstr "اطلاعات فرسته غیرقابل دسترسی."

#: src/components/account-info.jsx:928
msgid "View post stats"
msgstr "نمایش اطلاعات فرسته"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-info.jsx:1091
msgid "Last post: <0>{0}</0>"
msgstr "آخرین فرسته: <0>{0}</0>"

#: src/components/account-info.jsx:1105
msgid "Muted"
msgstr "خموشانده"

#: src/components/account-info.jsx:1110
msgid "Blocked"
msgstr "مسدودشده"

#: src/components/account-info.jsx:1119
msgid "Private note"
msgstr ""

#: src/components/account-info.jsx:1176
msgid "Mention <0>@{username}</0>"
msgstr "اشاره به <0>@{username}</0>"

#: src/components/account-info.jsx:1188
msgid "Translate bio"
msgstr "ترجمهٔ شرح حال"

#: src/components/account-info.jsx:1199
msgid "Edit private note"
msgstr ""

#: src/components/account-info.jsx:1199
msgid "Add private note"
msgstr ""

#: src/components/account-info.jsx:1219
msgid "Notifications enabled for @{username}'s posts."
msgstr ""

#: src/components/account-info.jsx:1220
msgid " Notifications disabled for @{username}'s posts."
msgstr ""

#: src/components/account-info.jsx:1232
msgid "Disable notifications"
msgstr ""

#: src/components/account-info.jsx:1233
msgid "Enable notifications"
msgstr ""

#: src/components/account-info.jsx:1250
msgid "Boosts from @{username} enabled."
msgstr ""

#: src/components/account-info.jsx:1251
msgid "Boosts from @{username} disabled."
msgstr ""

#: src/components/account-info.jsx:1262
msgid "Disable boosts"
msgstr ""

#: src/components/account-info.jsx:1262
msgid "Enable boosts"
msgstr ""

#: src/components/account-info.jsx:1278
#: src/components/account-info.jsx:1288
#: src/components/account-info.jsx:1891
msgid "Add/Remove from Lists"
msgstr "افزودن/حذف کردن از سیاهه‌ها"

#: src/components/account-info.jsx:1327
#: src/components/status.jsx:1210
msgid "Link copied"
msgstr "پیوند رونوشت شد"

#: src/components/account-info.jsx:1330
#: src/components/status.jsx:1213
msgid "Unable to copy link"
msgstr "ناتوان در رونوشت برداشتن از پیوند"

#: src/components/account-info.jsx:1336
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1219
#: src/components/status.jsx:3296
msgid "Copy"
msgstr "رونوشت"

#: src/components/account-info.jsx:1351
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1235
msgid "Sharing doesn't seem to work."
msgstr "انگار همرسانی کار نمیکند."

#: src/components/account-info.jsx:1357
#: src/components/status.jsx:1241
msgid "Share…"
msgstr "همرسانی…"

#: src/components/account-info.jsx:1377
msgid "Unmuted @{username}"
msgstr ""

#: src/components/account-info.jsx:1389
msgid "Unmute <0>@{username}</0>"
msgstr "ناخموشاندن <0>@{username}</0>"

#: src/components/account-info.jsx:1405
msgid "Mute <0>@{username}</0>…"
msgstr "خموشاندن <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/account-info.jsx:1437
msgid "Muted @{username} for {0}"
msgstr ""

#: src/components/account-info.jsx:1449
msgid "Unable to mute @{username}"
msgstr ""

#: src/components/account-info.jsx:1470
msgid "Remove <0>@{username}</0> from followers?"
msgstr "<0>@{username}</0> را از پی‌گرفتگان حذف میکنید؟"

#: src/components/account-info.jsx:1490
msgid "@{username} removed from followers"
msgstr ""

#: src/components/account-info.jsx:1502
msgid "Remove follower…"
msgstr "حذف کردن پی‌گرفته…"

#: src/components/account-info.jsx:1513
msgid "Block <0>@{username}</0>?"
msgstr "<0>@{username}</0> را مسدود میکنید؟"

#: src/components/account-info.jsx:1537
msgid "Unblocked @{username}"
msgstr ""

#: src/components/account-info.jsx:1545
msgid "Blocked @{username}"
msgstr ""

#: src/components/account-info.jsx:1553
msgid "Unable to unblock @{username}"
msgstr ""

#: src/components/account-info.jsx:1555
msgid "Unable to block @{username}"
msgstr ""

#: src/components/account-info.jsx:1565
msgid "Unblock <0>@{username}</0>"
msgstr "نامسدود کردن <0>@{username}</0>"

#: src/components/account-info.jsx:1574
msgid "Block <0>@{username}</0>…"
msgstr "مسدود کردن <0>@{username}</0>…"

#: src/components/account-info.jsx:1591
msgid "Report <0>@{username}</0>…"
msgstr "گزارش دادن <0>@{username}</0>…"

#: src/components/account-info.jsx:1611
#: src/components/account-info.jsx:2145
msgid "Edit profile"
msgstr "ویرایش نمایه"

#: src/components/account-info.jsx:1647
msgid "Withdraw follow request?"
msgstr ""

#. placeholder {1}: info.acct || info.username
#: src/components/account-info.jsx:1648
msgid "Unfollow @{1}?"
msgstr ""

#: src/components/account-info.jsx:1699
msgid "Unfollow…"
msgstr "پی نگرفتن…"

#: src/components/account-info.jsx:1708
msgid "Withdraw…"
msgstr "برگرداندن…"

#: src/components/account-info.jsx:1715
#: src/components/account-info.jsx:1719
#: src/pages/hashtag.jsx:262
msgid "Follow"
msgstr "پی گرفتن"

#: src/components/account-info.jsx:1831
#: src/components/account-info.jsx:1886
#: src/components/account-info.jsx:2020
#: src/components/account-info.jsx:2140
#: src/components/account-sheet.jsx:38
#: src/components/compose.jsx:881
#: src/components/compose.jsx:2728
#: src/components/compose.jsx:3202
#: src/components/compose.jsx:3411
#: src/components/compose.jsx:3641
#: src/components/drafts.jsx:59
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:143
#: src/components/keyboard-shortcuts-help.jsx:42
#: src/components/list-add-edit.jsx:36
#: src/components/media-alt-modal.jsx:34
#: src/components/media-modal.jsx:322
#: src/components/notification-service.jsx:157
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:3020
#: src/components/status.jsx:3260
#: src/components/status.jsx:3760
#: src/pages/accounts.jsx:37
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:276
#: src/pages/notifications.jsx:915
#: src/pages/scheduled-posts.jsx:257
#: src/pages/settings.jsx:78
#: src/pages/status.jsx:1301
msgid "Close"
msgstr "بستن"

#: src/components/account-info.jsx:1836
msgid "Translated Bio"
msgstr "شرح حال ترجمه شد"

#: src/components/account-info.jsx:1931
msgid "Unable to remove from list."
msgstr ""

#: src/components/account-info.jsx:1932
msgid "Unable to add to list."
msgstr ""

#: src/components/account-info.jsx:1951
#: src/pages/lists.jsx:105
msgid "Unable to load lists."
msgstr "ناتوانی در بارگذاری سیاهه‌ها."

#: src/components/account-info.jsx:1955
msgid "No lists."
msgstr "سیاهه‌ای نیست."

#: src/components/account-info.jsx:1966
#: src/components/list-add-edit.jsx:40
#: src/pages/lists.jsx:59
msgid "New list"
msgstr "سیاهه جدید"

#. placeholder {0}: account?.username || account?.acct
#: src/components/account-info.jsx:2025
msgid "Private note about <0>@{0}</0>"
msgstr "یادداشت خصوصی دربارهٔ <0>@{0}</0>"

#: src/components/account-info.jsx:2055
msgid "Unable to update private note."
msgstr ""

#: src/components/account-info.jsx:2078
#: src/components/account-info.jsx:2376
msgid "Cancel"
msgstr "لغو"

#: src/components/account-info.jsx:2083
msgid "Save & close"
msgstr "ذخیره و بستن"

#: src/components/account-info.jsx:2200
msgid "Unable to update profile."
msgstr ""

#: src/components/account-info.jsx:2207
msgid "Header picture"
msgstr ""

#: src/components/account-info.jsx:2259
msgid "Profile picture"
msgstr ""

#: src/components/account-info.jsx:2311
#: src/components/list-add-edit.jsx:105
msgid "Name"
msgstr "نام"

#: src/components/account-info.jsx:2324
msgid "Bio"
msgstr "شرح حال"

#: src/components/account-info.jsx:2337
msgid "Extra fields"
msgstr "مورد اضافی"

#: src/components/account-info.jsx:2343
msgid "Label"
msgstr "برچسب"

#: src/components/account-info.jsx:2346
msgid "Content"
msgstr "محتوا"

#: src/components/account-info.jsx:2379
#: src/components/list-add-edit.jsx:150
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:981
msgid "Save"
msgstr "ذخیره"

#: src/components/account-info.jsx:2433
msgid "username"
msgstr "نام کاربری"

#: src/components/account-info.jsx:2437
msgid "server domain name"
msgstr "سامانهٔ نام دامنه"

#: src/components/background-service.jsx:151
msgid "Cloak mode disabled"
msgstr "حالت پوشش غیرفعال شد"

#: src/components/background-service.jsx:151
msgid "Cloak mode enabled"
msgstr "حالت پوشش فعال شد"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:176
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:439
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:560
#: src/pages/scheduled-posts.jsx:72
msgid "Home"
msgstr "خانه"

#: src/components/compose-button.jsx:135
#: src/compose.jsx:38
msgid "Compose"
msgstr "ترکیب"

#: src/components/compose-button.jsx:162
#: src/components/nav-menu.jsx:260
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:76
msgid "Scheduled Posts"
msgstr ""

#: src/components/compose-button.jsx:175
msgid "Add to thread"
msgstr ""

#: src/components/compose.jsx:211
msgid "Take photo or video"
msgstr ""

#: src/components/compose.jsx:212
msgid "Add media"
msgstr ""

#: src/components/compose.jsx:213
msgid "Add custom emoji"
msgstr "افزودن شکلک شخصی‌سازی‌شده"

#: src/components/compose.jsx:214
msgid "Add GIF"
msgstr ""

#: src/components/compose.jsx:215
msgid "Add poll"
msgstr "افزودن نظرسنجی"

#: src/components/compose.jsx:216
msgid "Schedule post"
msgstr ""

#: src/components/compose.jsx:415
msgid "You have unsaved changes. Discard this post?"
msgstr "شما تغییرات ذخیره‌نشده دارید. این فرسته را رها میکنید؟"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:644
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:654
#: src/components/compose.jsx:672
#: src/components/compose.jsx:1777
#: src/components/compose.jsx:1902
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {فقط میتوانید تا ۱ پرونده الصاق کنید.} other {فقط میتوانید تا # پرونده الصاق کنید.}}"

#: src/components/compose.jsx:862
msgid "Pop out"
msgstr ""

#: src/components/compose.jsx:869
msgid "Minimize"
msgstr "کوچک‌کردن"

#: src/components/compose.jsx:905
msgid "Looks like you closed the parent window."
msgstr "انگار شما پنجرهٔ اصلی را بستید."

#: src/components/compose.jsx:912
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "انگار شما در حال حاضر یک زمینهٔ نوشتن در پنجرهٔ مادر دارید که در حال حاضر درحال انتشار است. لطفا صبر کنید تا تمام شود و بعدا دوباره تلاش کنید."

#: src/components/compose.jsx:917
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "انگار شما در حال حاضر یک زمینهٔ نوشتن در پنجرهٔ مادر دارید. وارد شدن به این پنجره تغییراتی که در پنجرهٔ مادر انجام داده‌اید را رها میکند. ادامه میدهید؟"

#: src/components/compose.jsx:960
msgid "Pop in"
msgstr ""

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:970
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "درحال پاسخ دادن به فرستهٔ @{0} (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:980
msgid "Replying to @{0}’s post"
msgstr "درحال پاسخ دادن به فرستهٔ @{0}"

#: src/components/compose.jsx:993
msgid "Editing source post"
msgstr "ویرایش فرستهٔ منبع"

#: src/components/compose.jsx:1046
msgid "Poll must have at least 2 options"
msgstr "نظرسنجی حداقل باید ۲ گزینه داشته باشد"

#: src/components/compose.jsx:1050
msgid "Some poll choices are empty"
msgstr "بعضی گزینه‌های نظرسنجی خالی هستند"

#: src/components/compose.jsx:1063
msgid "Some media have no descriptions. Continue?"
msgstr "بعضی از رسانه‌ها شرح ندارند. ادامه میدهید؟"

#: src/components/compose.jsx:1115
msgid "Attachment #{i} failed"
msgstr "پیوست #{i} شکست خورد"

#: src/components/compose.jsx:1211
#: src/components/status.jsx:2098
#: src/components/timeline.jsx:989
msgid "Content warning"
msgstr "هشدار محتوا"

#: src/components/compose.jsx:1227
msgid "Content warning or sensitive media"
msgstr "هشدار محتوا یا رسانهٔ حساس"

#: src/components/compose.jsx:1263
#: src/components/status.jsx:94
#: src/pages/settings.jsx:306
msgid "Public"
msgstr "همگانی"

#: src/components/compose.jsx:1268
#: src/components/nav-menu.jsx:344
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:95
msgid "Local"
msgstr "محلی"

#: src/components/compose.jsx:1272
#: src/components/status.jsx:96
#: src/pages/settings.jsx:309
msgid "Unlisted"
msgstr "فهرست‌نشده"

#: src/components/compose.jsx:1275
#: src/components/status.jsx:97
#: src/pages/settings.jsx:312
msgid "Followers only"
msgstr "فقط پی‌گیرنده"

#: src/components/compose.jsx:1278
#: src/components/status.jsx:98
#: src/components/status.jsx:1976
msgid "Private mention"
msgstr "اشارهٔ خصوصی"

#: src/components/compose.jsx:1287
msgid "Post your reply"
msgstr "پاسختان را بفرستید"

#: src/components/compose.jsx:1289
msgid "Edit your post"
msgstr "فرسته‌تان را ویرایش کنید"

#: src/components/compose.jsx:1290
msgid "What are you doing?"
msgstr "چکار میکنید؟"

#: src/components/compose.jsx:1368
msgid "Mark media as sensitive"
msgstr "علامت‌گذاری رسانه به عنوان حساس"

#: src/components/compose.jsx:1405
msgid "Posting on <0/>"
msgstr ""

#: src/components/compose.jsx:1436
#: src/components/compose.jsx:3260
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:362
msgid "Add"
msgstr "افزودن"

#: src/components/compose.jsx:1662
msgid "Schedule"
msgstr ""

#: src/components/compose.jsx:1664
#: src/components/keyboard-shortcuts-help.jsx:154
#: src/components/status.jsx:984
#: src/components/status.jsx:1750
#: src/components/status.jsx:1751
#: src/components/status.jsx:2421
msgid "Reply"
msgstr "پاسخ دادن"

#: src/components/compose.jsx:1666
msgid "Update"
msgstr "بروزرسانی"

#: src/components/compose.jsx:1667
msgctxt "Submit button in composer"
msgid "Post"
msgstr "ارسال"

#: src/components/compose.jsx:1789
msgid "Downloading GIF…"
msgstr "بارگیری جیف…"

#: src/components/compose.jsx:1817
msgid "Failed to download GIF"
msgstr "بارگیری جیف ناموفق بود"

#: src/components/compose.jsx:2032
#: src/components/compose.jsx:2109
#: src/components/nav-menu.jsx:239
msgid "More…"
msgstr "بیشتر…"

#: src/components/compose.jsx:2541
msgid "Uploaded"
msgstr "بارگذاری شد"

#: src/components/compose.jsx:2554
msgid "Image description"
msgstr "شرح تصویر"

#: src/components/compose.jsx:2555
msgid "Video description"
msgstr "شرح ویدئو"

#: src/components/compose.jsx:2556
msgid "Audio description"
msgstr "شرح صدا"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#: src/components/compose.jsx:2592
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "اندازهٔ پرونده خیلی بزرگ است. بارگذاری ممکن است با مشکل مواجه شود. کم کردن اندازهٔ پرونده از {0} به {1} یا پایین‌تر را امتحان کنید."

#. placeholder {2}: i18n.number( width, )
#. placeholder {3}: i18n.number(height)
#. placeholder {4}: i18n.number(newWidth)
#. placeholder {5}: i18n.number( newHeight, )
#: src/components/compose.jsx:2604
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {2}×{3}px to {4}×{5}px."
msgstr ""

#. placeholder {6}: prettyBytes( videoSize, )
#. placeholder {7}: prettyBytes(videoSizeLimit)
#: src/components/compose.jsx:2612
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {6} to {7} or lower."
msgstr ""

#. placeholder {8}: i18n.number( width, )
#. placeholder {9}: i18n.number(height)
#. placeholder {10}: i18n.number(newWidth)
#. placeholder {11}: i18n.number( newHeight, )
#: src/components/compose.jsx:2624
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {8}×{9}px to {10}×{11}px."
msgstr ""

#: src/components/compose.jsx:2632
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "ترخ نوسازی بسیار زیاد است. بارگذاری ممکن است با مشکل موجه شود."

#: src/components/compose.jsx:2692
#: src/components/compose.jsx:2942
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "حذف کردن"

#: src/components/compose.jsx:2709
#: src/compose.jsx:84
msgid "Error"
msgstr "خطا"

#: src/components/compose.jsx:2734
msgid "Edit image description"
msgstr "ویرایش کردن شرح تصویر"

#: src/components/compose.jsx:2735
msgid "Edit video description"
msgstr "ویرایش کردن شرح ویدئو"

#: src/components/compose.jsx:2736
msgid "Edit audio description"
msgstr "ویرایش کردن شرح صدا"

#: src/components/compose.jsx:2781
#: src/components/compose.jsx:2830
msgid "Generating description. Please wait…"
msgstr "تولید شرح. لطفا صبر کنید…"

#. placeholder {12}: e.message
#: src/components/compose.jsx:2801
msgid "Failed to generate description: {12}"
msgstr ""

#: src/components/compose.jsx:2802
msgid "Failed to generate description"
msgstr "شکست در تولید شرح"

#: src/components/compose.jsx:2814
#: src/components/compose.jsx:2820
#: src/components/compose.jsx:2866
msgid "Generate description…"
msgstr "تولید شرح…"

#. placeholder {13}: e?.message ? `: ${e.message}` : ''
#: src/components/compose.jsx:2853
msgid "Failed to generate description{13}"
msgstr ""

#. placeholder {0}: localeCode2Text(lang)
#: src/components/compose.jsx:2868
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— آزمایشگاهی</0>"

#: src/components/compose.jsx:2887
msgid "Done"
msgstr "اتمام"

#. placeholder {0}: i + 1
#: src/components/compose.jsx:2923
msgid "Choice {0}"
msgstr ""

#: src/components/compose.jsx:2970
msgid "Multiple choices"
msgstr "گزینه‌های چندگانه"

#: src/components/compose.jsx:2973
msgid "Duration"
msgstr "طول"

#: src/components/compose.jsx:3004
msgid "Remove poll"
msgstr "حذف نظرسنجی"

#: src/components/compose.jsx:3219
msgid "Search accounts"
msgstr ""

#: src/components/compose.jsx:3273
#: src/components/generic-accounts.jsx:228
msgid "Error loading accounts"
msgstr "خطا در بارگذاری حساب‌ها"

#: src/components/compose.jsx:3417
msgid "Custom emojis"
msgstr "شکلک‌های شخصی‌سازی‌شده"

#: src/components/compose.jsx:3437
msgid "Search emoji"
msgstr ""

#: src/components/compose.jsx:3468
msgid "Error loading custom emojis"
msgstr "خطا در بارگذاری شکلک‌های شخصی‌سازی‌شده"

#: src/components/compose.jsx:3479
msgid "Recently used"
msgstr ""

#: src/components/compose.jsx:3480
msgid "Others"
msgstr ""

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/compose.jsx:3518
msgid "{0} more…"
msgstr "{0} بیشتر…"

#: src/components/compose.jsx:3656
msgid "Search GIFs"
msgstr ""

#: src/components/compose.jsx:3671
msgid "Powered by GIPHY"
msgstr ""

#: src/components/compose.jsx:3679
msgid "Type to search GIFs"
msgstr "برای جستجوی جیف‌ها بنویسید"

#: src/components/compose.jsx:3777
#: src/components/media-modal.jsx:464
#: src/components/timeline.jsx:893
msgid "Previous"
msgstr "پیشین"

#: src/components/compose.jsx:3795
#: src/components/media-modal.jsx:483
#: src/components/timeline.jsx:910
msgid "Next"
msgstr "پسین"

#: src/components/compose.jsx:3812
msgid "Error loading GIFs"
msgstr "خطا در بارگذاری جیف‌ها"

#: src/components/drafts.jsx:64
#: src/pages/settings.jsx:693
msgid "Unsent drafts"
msgstr "پیش‌نویس‌های ارسال‌نشده"

#: src/components/drafts.jsx:69
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "انگار پیش‌نویس‌های ارسال‌نشده دارید. بیایید از جایی که رها کرده‌اید ادامه دهیم."

#: src/components/drafts.jsx:103
msgid "Delete this draft?"
msgstr "این پیش‌نویس را حذف میکنید؟"

#: src/components/drafts.jsx:118
msgid "Error deleting draft! Please try again."
msgstr "خطا در حذف پیش‌نویس! لطفا دوباره تلاش کنید."

#: src/components/drafts.jsx:128
#: src/components/list-add-edit.jsx:186
#: src/components/status.jsx:1385
#: src/pages/filters.jsx:587
#: src/pages/scheduled-posts.jsx:367
msgid "Delete…"
msgstr "حذف…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr ""

#: src/components/drafts.jsx:172
msgid "Delete all drafts?"
msgstr "حذف کل پیش‌نویس‌ها؟"

#: src/components/drafts.jsx:190
msgid "Error deleting drafts! Please try again."
msgstr "خطا در حذف پیش‌نویس‌ها! لطفا دوباره تلاش کنید."

#: src/components/drafts.jsx:202
msgid "Delete all…"
msgstr "حذف همه…"

#: src/components/drafts.jsx:210
msgid "No drafts found."
msgstr "پیش‌نویسی یافت نشد."

#: src/components/drafts.jsx:247
#: src/pages/catchup.jsx:1929
msgid "Poll"
msgstr "نظرسنجی"

#: src/components/drafts.jsx:250
#: src/pages/account-statuses.jsx:360
msgid "Media"
msgstr "رسانه"

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr "باز کردن در پنجره‌ای جدید"

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:965
msgid "Accept"
msgstr "قبول کردن"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "رد کردن"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1249
msgid "Accepted"
msgstr "قبول شده"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "رد شده"

#: src/components/generic-accounts.jsx:146
#: src/components/notification.jsx:445
#: src/pages/accounts.jsx:42
#: src/pages/search.jsx:318
#: src/pages/search.jsx:351
msgid "Accounts"
msgstr "حساب‌های کاربری"

#: src/components/generic-accounts.jsx:206
#: src/components/timeline.jsx:521
#: src/pages/list.jsx:295
#: src/pages/notifications.jsx:895
#: src/pages/search.jsx:545
#: src/pages/status.jsx:1334
msgid "Show more…"
msgstr "نمایش بیشتر…"

#: src/components/generic-accounts.jsx:211
#: src/components/timeline.jsx:526
#: src/pages/search.jsx:550
msgid "The end."
msgstr "آخر."

#: src/components/generic-accounts.jsx:232
msgid "Nothing to show"
msgstr "چیزی برای نمایش نیست"

#: src/components/keyboard-shortcuts-help.jsx:46
#: src/components/nav-menu.jsx:363
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "میانبرهای صفحه کلید"

#: src/components/keyboard-shortcuts-help.jsx:54
msgid "Keyboard shortcuts help"
msgstr "راهنمای میانبرهای صفحه کلید"

#: src/components/keyboard-shortcuts-help.jsx:58
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "فرستهٔ پسین"

#: src/components/keyboard-shortcuts-help.jsx:62
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "فرستهٔ پیشین"

#: src/components/keyboard-shortcuts-help.jsx:66
msgid "Skip carousel to next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:68
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>تبدیل</0> + <1>ت</1>"

#: src/components/keyboard-shortcuts-help.jsx:74
msgid "Skip carousel to previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:76
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>تبدیل</0> + <1>ن</1>"

#: src/components/keyboard-shortcuts-help.jsx:82
msgid "Load new posts"
msgstr "بارگذاری فرسته‌های جدید"

#: src/components/keyboard-shortcuts-help.jsx:86
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "باز کردن اطلاعات فرسته"

#: src/components/keyboard-shortcuts-help.jsx:88
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>ورود</0> یا <1>خ</1>"

#: src/components/keyboard-shortcuts-help.jsx:95
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "گسترش دادن هشدار محتوا یا<0/>تغییر حالت رشتهٔ گسترده/بسته"

#: src/components/keyboard-shortcuts-help.jsx:104
msgid "Close post or dialogs"
msgstr "بستن فرسته یا پنجره"

#: src/components/keyboard-shortcuts-help.jsx:106
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>فرار</0> یا <1>پس‌بر</1>"

#: src/components/keyboard-shortcuts-help.jsx:112
msgid "Focus column in multi-column mode"
msgstr "ستون متمرکز در حالت چندستونه"

#: src/components/keyboard-shortcuts-help.jsx:114
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>۱</0> تا <1>۹</1>"

#: src/components/keyboard-shortcuts-help.jsx:120
msgid "Focus next column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "Focus previous column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:128
msgid "Compose new post"
msgstr "نوشتن فرستهٔ جدید"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "Compose new post (new window)"
msgstr "نوشتن فرستهٔ جدید (پنجرهٔ جدید)"

#: src/components/keyboard-shortcuts-help.jsx:135
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>تبدیل</0> + <1>ز</1>"

#: src/components/keyboard-shortcuts-help.jsx:141
msgid "Send post"
msgstr "ارسال فرسته"

#: src/components/keyboard-shortcuts-help.jsx:143
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>مهار</0> + <1>ورود</1> یا <2>⌘</2> + <3>ورود</3>"

#: src/components/keyboard-shortcuts-help.jsx:150
#: src/components/nav-menu.jsx:332
#: src/components/search-form.jsx:73
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:46
#: src/pages/search.jsx:300
msgid "Search"
msgstr "جستجو"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "Reply (new window)"
msgstr "پاسخ دادن (پنجرهٔ جدید)"

#: src/components/keyboard-shortcuts-help.jsx:161
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>تبدیل</0> + <1>ق</1>"

#: src/components/keyboard-shortcuts-help.jsx:167
msgid "Like (favourite)"
msgstr "پسندیدن (مورد علاقه)"

#: src/components/keyboard-shortcuts-help.jsx:169
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>م</0> یا <1>ب</1>"

#: src/components/keyboard-shortcuts-help.jsx:175
#: src/components/status.jsx:992
#: src/components/status.jsx:2448
#: src/components/status.jsx:2471
#: src/components/status.jsx:2472
msgid "Boost"
msgstr "تقویت"

#: src/components/keyboard-shortcuts-help.jsx:177
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>تبدیل</0> + <1>ذ</1>"

#: src/components/keyboard-shortcuts-help.jsx:183
#: src/components/status.jsx:1055
#: src/components/status.jsx:2496
#: src/components/status.jsx:2497
msgid "Bookmark"
msgstr "نشانک‌گذاری"

#: src/components/keyboard-shortcuts-help.jsx:187
msgid "Toggle Cloak mode"
msgstr "تغییر وضعیت حالت پوشش"

#: src/components/keyboard-shortcuts-help.jsx:189
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>تبدیل</0> + <1>دگرساز</1> + <2>ن</2>"

#: src/components/list-add-edit.jsx:40
msgid "Edit list"
msgstr "ویرایش سیاهه"

#: src/components/list-add-edit.jsx:96
msgid "Unable to edit list."
msgstr "ناتوان در ویرایش سیاهه."

#: src/components/list-add-edit.jsx:97
msgid "Unable to create list."
msgstr "ناتوان در ایجاد سیاهه."

#: src/components/list-add-edit.jsx:125
msgid "Show replies to list members"
msgstr "نمایش پاسخ‌ها به سیاههٔ اعضا"

#: src/components/list-add-edit.jsx:128
msgid "Show replies to people I follow"
msgstr "نمایش پاسخ‌ها به افرادی که پی میگیرم"

#: src/components/list-add-edit.jsx:131
msgid "Don't show replies"
msgstr "پاسخ‌ها را نمایش نده"

#: src/components/list-add-edit.jsx:144
msgid "Hide posts on this list from Home/Following"
msgstr "پنهان کردن فرسته‌ها در این سیاهه از خانه/پی‌گرفته"

#: src/components/list-add-edit.jsx:150
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "ایجاد"

#: src/components/list-add-edit.jsx:157
msgid "Delete this list?"
msgstr "این سیاهه را حذف میکنید؟"

#: src/components/list-add-edit.jsx:176
msgid "Unable to delete list."
msgstr "ناتوان در حذف سیاهه."

#: src/components/media-alt-modal.jsx:39
#: src/components/media.jsx:51
msgid "Media description"
msgstr "شرح رسانه"

#: src/components/media-alt-modal.jsx:58
#: src/components/status.jsx:1099
#: src/components/status.jsx:1126
#: src/components/translation-block.jsx:215
msgid "Translate"
msgstr "ترجمه"

#: src/components/media-alt-modal.jsx:69
#: src/components/status.jsx:1113
#: src/components/status.jsx:1140
msgid "Speak"
msgstr "حرف زدن"

#: src/components/media-modal.jsx:369
msgid "Open original media in new window"
msgstr "باز کردن رسانهٔ اصلی در پنجرهٔ جدید"

#: src/components/media-modal.jsx:373
msgid "Open original media"
msgstr "باز کردن رسانهٔ اصلی"

#: src/components/media-modal.jsx:389
msgid "Attempting to describe image. Please wait…"
msgstr "تلاش برای شرح دادن تصویر. لطفا صبر کنید…"

#: src/components/media-modal.jsx:404
msgid "Failed to describe image"
msgstr "شکست در شرح دادن تصویر"

#: src/components/media-modal.jsx:414
msgid "Describe image…"
msgstr "شرح دادن تصویر…"

#: src/components/media-modal.jsx:438
msgid "View post"
msgstr "نمایش فرسته"

#: src/components/media-post.jsx:128
msgid "Sensitive media"
msgstr "رسانهٔ حساس"

#: src/components/media-post.jsx:133
msgid "Filtered: {filterTitleStr}"
msgstr "پالایش‌شده: {filterTitleStr}"

#: src/components/media-post.jsx:134
#: src/components/status.jsx:3590
#: src/components/status.jsx:3686
#: src/components/status.jsx:3764
#: src/components/timeline.jsx:978
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1877
msgid "Filtered"
msgstr "پالایش‌شده"

#: src/components/media.jsx:414
msgid "Open file"
msgstr ""

#: src/components/modals.jsx:75
msgid "Post scheduled"
msgstr ""

#: src/components/modals.jsx:76
msgid "Post published. Check it out."
msgstr "فرسته منتشر شد. آن را ببینید."

#: src/components/modals.jsx:78
msgid "Reply scheduled"
msgstr ""

#: src/components/modals.jsx:79
msgid "Reply posted. Check it out."
msgstr "پاسخ ارسال شد. آن را ببینید."

#: src/components/modals.jsx:80
msgid "Post updated. Check it out."
msgstr "فرسته بروزرسانی شد. آن را ببینید."

#: src/components/nav-menu.jsx:118
msgid "Menu"
msgstr "فهرست"

#: src/components/nav-menu.jsx:154
msgid "Reload page now to update?"
msgstr "صفحه را برای بروزرسانی بارگذاری مجدد میکنید؟"

#: src/components/nav-menu.jsx:166
msgid "New update available…"
msgstr "بروزرسانی جدید در دسترس است…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:185
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:23
#: src/pages/following.jsx:142
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:192
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr ""

#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:225
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:168
#: src/pages/settings.jsx:1143
#: src/pages/trending.jsx:382
msgid "Mentions"
msgstr "اشاره‌ها"

#: src/components/nav-menu.jsx:206
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:23
#: src/pages/home.jsx:85
#: src/pages/home.jsx:185
#: src/pages/notifications.jsx:113
#: src/pages/notifications.jsx:564
msgid "Notifications"
msgstr "آگاهی‌ها"

#: src/components/nav-menu.jsx:209
msgid "New"
msgstr "جدید"

#: src/components/nav-menu.jsx:220
msgid "Profile"
msgstr "نمایه"

#: src/components/nav-menu.jsx:228
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:24
msgid "Bookmarks"
msgstr "نشانک‌گذاری‌ها"

#: src/components/nav-menu.jsx:248
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2064
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:24
#: src/pages/settings.jsx:1147
msgid "Likes"
msgstr "برگزیده‌ها"

#: src/components/nav-menu.jsx:254
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "برچسب‌های پی‌گرفته‌شده"

#: src/components/nav-menu.jsx:268
#: src/pages/account-statuses.jsx:326
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:340
msgid "Filters"
msgstr "پالایه‌ها"

#: src/components/nav-menu.jsx:276
msgid "Muted users"
msgstr "کاربران خموشیده‌شده"

#: src/components/nav-menu.jsx:284
msgid "Muted users…"
msgstr "کاربران خموشیده‌شده…"

#: src/components/nav-menu.jsx:291
msgid "Blocked users"
msgstr "کاربران مسدودشده"

#: src/components/nav-menu.jsx:299
msgid "Blocked users…"
msgstr "کاربران مسدودشده…"

#: src/components/nav-menu.jsx:311
msgid "Accounts…"
msgstr "حساب‌ها…"

#: src/components/nav-menu.jsx:321
#: src/pages/login.jsx:27
#: src/pages/login.jsx:190
#: src/pages/status.jsx:837
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr "ورود"

#: src/components/nav-menu.jsx:338
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:442
msgid "Trending"
msgstr "داغ"

#: src/components/nav-menu.jsx:350
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "خودگردان"

#: src/components/nav-menu.jsx:373
msgid "Shortcuts / Columns…"
msgstr "میانبرها / ستون‌ها…"

#: src/components/nav-menu.jsx:383
#: src/components/nav-menu.jsx:397
msgid "Settings…"
msgstr "تنظیمات…"

#: src/components/nav-menu.jsx:427
#: src/components/nav-menu.jsx:454
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:17
#: src/pages/lists.jsx:51
msgid "Lists"
msgstr "سیاهه‌ها"

#: src/components/nav-menu.jsx:435
#: src/components/shortcuts.jsx:214
#: src/pages/list.jsx:134
msgid "All Lists"
msgstr "همهٔ سیاهه‌ها"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "آگاهی"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "این آگاهی از حساب دیگر شماست."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "نمایش همهٔ آگاهی‌ها"

#: src/components/notification.jsx:71
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} روی فرستهٔ شما با {emojiObject} بازخورد داد"

#: src/components/notification.jsx:78
msgid "{account} published a post."
msgstr "{account} یک فرسته منتشر کرد."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:86
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:129
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:143
msgid "{account} requested to follow you."
msgstr "{account} درخواست کرد شما را پی‌گیری کند."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:152
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} پاسختان را پسندید.} other {{account} فرسته‌تان را پسندید.}}} other {{account} {postsCount} فرسته از فرسته‌هایتان را پسندید.}}} other {{postType, select, reply {<0><1>{0}</1> نفر</0> پاسختان را پسندیدند.} other {<2><3>{1}</3> نفر</2> فرسته‌تان را پسندیدند.}}}}"

#: src/components/notification.jsx:194
msgid "A poll you have voted in or created has ended."
msgstr "یک نظرسنجی که در آن رأی داده‌اید یا آن را ایجاد کرده‌اید پایان یافته است."

#: src/components/notification.jsx:195
msgid "A poll you have created has ended."
msgstr "یک نظرسنجی که شما ایجاد کرده‌اید پایان یافته است."

#: src/components/notification.jsx:196
msgid "A poll you have voted in has ended."
msgstr "یک نظرسنجی که شما در آن رأی داده‌اید پایان یافته است."

#: src/components/notification.jsx:197
msgid "A post you interacted with has been edited."
msgstr "یک فرسته که شما با آن تعامل داشته‌اید تغییر یافته است."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:205
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} پاسختان را تقویت کرد و پسندید.} other {{account} فرسته‌تان را تقویت کرد و پسندید.}}} other {{account} {postsCount} فرسته از فرسته‌هایتان را تقویت کرد و پسندید.}}} other {{postType, select,reply {<0><1>{0}</1> نفر</0> پاسختان را تقویت کردند و پسندیدند.} other {<2><3>{1}</3> نفر</2> فرسته‌تان را تقویت کردند و پسندیدند.}}}}"

#: src/components/notification.jsx:247
msgid "{account} signed up."
msgstr "{account} ثبت‌نام شد."

#: src/components/notification.jsx:249
msgid "{account} reported {targetAccount}"
msgstr "{account} {targetAccount} را گزارش کرد"

#: src/components/notification.jsx:254
msgid "Lost connections with <0>{name}</0>."
msgstr "اتصال از دست رفته با <0>{name}</0>."

#: src/components/notification.jsx:260
msgid "Moderation warning"
msgstr ""

#: src/components/notification.jsx:265
msgid "Your {year} #Wrapstodon is here!"
msgstr ""

#: src/components/notification.jsx:271
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "یک مدیر از <0>{from}</0> <1>{targetName}</1> را تعلیق کرده است، معنی‌اش این است که شما دیگر نمیتوانید بروزرسانی‌هایی از آنها دریافت کنید یا با آنها تعامل کنید."

#: src/components/notification.jsx:277
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "یک مدیر از <0>{from}</0> <1>{targetName}</1> را مسدود کرده است. پی‌گیرنده‌های تأثیرپذیرفته: {followersCount}، پی‌گرفته‌های تأثیرپذیرفته: {followingCount}."

#: src/components/notification.jsx:283
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "شما <0>{targetName}</0> را مسدود کرده‌اید. پی‌گیرنده حذف‌شده: {followersCount}، پی‌گرفته‌های حذف‌شده: {followingCount}."

#: src/components/notification.jsx:291
msgid "Your account has received a moderation warning."
msgstr ""

#: src/components/notification.jsx:292
msgid "Your account has been disabled."
msgstr "حساب کاربری شما غیرفعال شده است."

#: src/components/notification.jsx:293
msgid "Some of your posts have been marked as sensitive."
msgstr "بعضی از فرسته‌های شما به عنوان حساس نشانه‌گذاری شده‌اند."

#: src/components/notification.jsx:294
msgid "Some of your posts have been deleted."
msgstr "بعضی از فرسته‌های شما حذف شده‌اند."

#: src/components/notification.jsx:295
msgid "Your posts will be marked as sensitive from now on."
msgstr "از این به بعد فرسته‌های شما به عنوان حساس نشانه‌گذاری خواهند شد."

#: src/components/notification.jsx:296
msgid "Your account has been limited."
msgstr "حساب کاربری شما محدود شده است."

#: src/components/notification.jsx:297
msgid "Your account has been suspended."
msgstr "حساب کاربری شما تعلیق شده است."

#: src/components/notification.jsx:372
msgid "[Unknown notification type: {type}]"
msgstr "[نوع ناشناختهٔ آگاهی: {type}]"

#: src/components/notification.jsx:441
#: src/components/status.jsx:1069
#: src/components/status.jsx:1079
msgid "Boosted/Liked by…"
msgstr "تقویت‌شده/برگزیده‌شده توسط…"

#: src/components/notification.jsx:442
msgid "Liked by…"
msgstr "برگزیده‌شده توسط…"

#: src/components/notification.jsx:443
msgid "Boosted by…"
msgstr "تقویت‌شده توسط…"

#: src/components/notification.jsx:444
msgid "Followed by…"
msgstr "پی‌گرفته‌شده توسط…"

#: src/components/notification.jsx:515
#: src/components/notification.jsx:531
msgid "Learn more <0/>"
msgstr "بیشتر بدانید <0/>"

#: src/components/notification.jsx:540
msgid "View #Wrapstodon"
msgstr ""

#: src/components/notification.jsx:770
#: src/components/status.jsx:297
msgid "Read more →"
msgstr "بیشتر خوانید ←"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "رأی داده شده"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr ""

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "پنهان کردن نتایج"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "رأی دادن"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/scheduled-posts.jsx:98
#: src/pages/status.jsx:1203
#: src/pages/status.jsx:1226
msgid "Refresh"
msgstr "بارگذاری مجدد"

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "نمایش نتایج"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr ""

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr ""

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "پایان یافته <0/>"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "پایان‌یافته"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "در حال اتمام <0/>"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "در حال اتمام"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:59
msgid "{0}s"
msgstr "{0}ث"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:64
msgid "{0}m"
msgstr "{0}د"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:69
msgid "{0}h"
msgstr "{0}س"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr ""

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr ""

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "قوانین خاص کارساز را نقض میکند"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr ""

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "دیگر"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "گزارش دادن فرسته"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "گزارش دادن @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "فرسته گزارش شد"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "نمایه گزارش شد"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "ناتوان در گزارش دادن فرسته"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "ناتوان در گزارش دادن نمایه"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "مشکل این فرسته چیست؟"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "مشکل این نمایه چیست؟"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "اطلاعات اضافی"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "هدایت کرد نبه <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "ارسال کردن گزارش"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "خموشیده {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr ""

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr ""

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr ""

#: src/components/search-form.jsx:203
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ حساب‌های کاربری، برچسب‌ها و فرسته‌ها</0>"

#: src/components/search-form.jsx:216
msgid "Posts with <0>{query}</0>"
msgstr "فرسته‌هایی با <0>{query}</0>"

#. placeholder {0}: query.replace(/^#/, '')
#: src/components/search-form.jsx:228
msgid "Posts tagged with <0>#{0}</0>"
msgstr "فرسته‌هایی که با <0>#{0}</0> برچسب‌گذاری شده‌اند"

#: src/components/search-form.jsx:242
msgid "Look up <0>{query}</0>"
msgstr "بررسی کردن <0>{query}</0>"

#: src/components/search-form.jsx:253
msgid "Accounts with <0>{query}</0>"
msgstr "حساب‌های کاربری با <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "خانه/پی‌گرفته"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "همگانی (محلی/نامتمرکز)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "حساب کاربری"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "برچسب"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "شناسهٔ سیاهه"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "فقط محلی"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:194
msgid "Instance"
msgstr "نمونه"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "پیشنهادی، مثلا mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr ""

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "مثلا PixelArt (حداکثر ۵، جدا شده با فاصله)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:356
msgid "Media only"
msgstr "فقط رسانه"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:191
msgid "Shortcuts"
msgstr "میانبرها"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "بتا"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "تعیین کردن سیاهه‌ای از میانبرهایی که به عنوان ظاهر میشوند:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "دکمهٔ شناور"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "نوار برگه/فهرست"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "چندستونه"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "غیرقابل دسترسی در حالت نمایش کنونی"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "حرکت به بالا"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "حرکت به پایین"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1347
#: src/pages/list.jsx:171
msgid "Edit"
msgstr "ویرایش"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "یک میانبر/ستون دیگر اضافه کنید تا این کار کند."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "هنوز ستونی وجود ندارد. روی دکمهٔ افزودن ستون بزنید."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "هنوز میانبری وجود ندارد. روی دکمهٔ افزودن میانبر بزنید."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "هنوز مطمئن نیستید چه چیزی اضافه کنید؟ اول<0/>اضافه کردن <1>خانه/پی‌گرفته و آگاهی‌ها</1> را امتحان کنید."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "بیشترین {SHORTCUTS_LIMIT} ستون"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "بیشترین {SHORTCUTS_LIMIT} میانبر"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "ورود/صدور"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "افزودن ستون…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "افزودن میانبر…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "سیاههٔ مخصوص پیشنهادی است. برای حالت چندستونه، سیاهه ضروری است، در غیر این صورت این ستون میتواند نمایش داده نشود."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "چندبرچسب پشتیبانی میشود. جداشده با فاصله."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "ویرایش میانبر"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "افزودن میانبر"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "خط زمانی"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "سیاهه"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "ورود/صدور <0>میانبرها</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "ورود"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "چسباندن میانبرها اینجا"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "بارگیری میانبرهای ذخیره‌شده از کارساز نمونه…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "ناتوان در بارگیری میانبرها"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "بارگیری میانبرها از کارساز نمونه"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr ""

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr ""

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "بازنویسی کردن…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "وارد کردن…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "صادر کردن"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "میانبرها رونوشت شدند"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "ناتوان در رونویسی از میانبرها"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "میانبرهای تنظیمات رونوشت شدند"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "ناتوان در رونویسی از میانبرهای تنظیمات"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "همرسانی"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "ذخیره کردن میانبرها در کارساز نمونه…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "میانبرها ذخیره شدند"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "ناتوان در ذخیره کردن میانبرها"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "همگام‌سازی با کارساز نمونه"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural,one {# نویسه} other {# نویسه‌ها}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "جیسون خالص میانبرها"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "ورود/صدور تنظیمات از/به کارساز نمونه (خیلی آزمایشی)"

#: src/components/status.jsx:571
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>تقویت کرد</1>"

#: src/components/status.jsx:670
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "متأسفانه نمونه‌ای که شما در آن وارد شده‌اید نمیتواند با این فرسته از یک نمونهٔ دیگر تعامل داشته باشد."

#. placeholder {0}: username || acct
#: src/components/status.jsx:823
msgid "Unliked @{0}'s post"
msgstr "فرستهٔ @{0} نابرگزیده شد"

#. placeholder {1}: username || acct
#: src/components/status.jsx:824
msgid "Liked @{1}'s post"
msgstr ""

#. placeholder {2}: username || acct
#: src/components/status.jsx:863
msgid "Unbookmarked @{2}'s post"
msgstr ""

#. placeholder {3}: username || acct
#: src/components/status.jsx:864
msgid "Bookmarked @{3}'s post"
msgstr ""

#: src/components/status.jsx:961
msgid "Some media have no descriptions."
msgstr "بعضی از رسانه‌ها شرح ندارند."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:968
msgid "Old post (<0>{0}</0>)"
msgstr "فرستهٔ قدیمی (<0>{0}</0>)"

#: src/components/status.jsx:992
#: src/components/status.jsx:1032
#: src/components/status.jsx:2448
#: src/components/status.jsx:2471
msgid "Unboost"
msgstr "ناتقویت"

#: src/components/status.jsx:1008
#: src/components/status.jsx:2463
msgid "Quote"
msgstr "نقل قول"

#. placeholder {4}: username || acct
#: src/components/status.jsx:1020
msgid "Unboosted @{4}'s post"
msgstr ""

#. placeholder {5}: username || acct
#: src/components/status.jsx:1021
msgid "Boosted @{5}'s post"
msgstr ""

#: src/components/status.jsx:1033
msgid "Boost…"
msgstr "تقویت…"

#: src/components/status.jsx:1045
#: src/components/status.jsx:1760
#: src/components/status.jsx:2484
msgid "Unlike"
msgstr "نابرگزیدن"

#: src/components/status.jsx:1046
#: src/components/status.jsx:1760
#: src/components/status.jsx:1761
#: src/components/status.jsx:2484
#: src/components/status.jsx:2485
msgid "Like"
msgstr "برگزیدن"

#: src/components/status.jsx:1055
#: src/components/status.jsx:2496
msgid "Unbookmark"
msgstr "نانشانک‌گذاری"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1163
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1184
msgid "Show Edit History"
msgstr "نمایش تاریخچهٔ ویرایش"

#: src/components/status.jsx:1187
msgid "Edited: {editedDateText}"
msgstr "ویرایش‌شده: {editedDateText}"

#: src/components/status.jsx:1254
#: src/components/status.jsx:3265
msgid "Embed post"
msgstr "فرستهٔ جاسازی‌شده"

#: src/components/status.jsx:1268
msgid "Conversation unmuted"
msgstr "گفتگو ناخموشیده شد"

#: src/components/status.jsx:1268
msgid "Conversation muted"
msgstr "گفتگو خموشیده شد"

#: src/components/status.jsx:1274
msgid "Unable to unmute conversation"
msgstr "ناتوان در ناخموشاندن گفتگو"

#: src/components/status.jsx:1275
msgid "Unable to mute conversation"
msgstr "ناتوان در خموشاندن گفتگو"

#: src/components/status.jsx:1284
msgid "Unmute conversation"
msgstr "ناخموشاندن گفتگو"

#: src/components/status.jsx:1291
msgid "Mute conversation"
msgstr "خموشاندن گفتگو"

#: src/components/status.jsx:1307
msgid "Post unpinned from profile"
msgstr "سنجاق فرسته از نمایه برداشته شد"

#: src/components/status.jsx:1308
msgid "Post pinned to profile"
msgstr "فرسته به نمایه سنجاق شد"

#: src/components/status.jsx:1313
msgid "Unable to unpin post"
msgstr "ناتوان در برداشتن سنجاق فرسته"

#: src/components/status.jsx:1313
msgid "Unable to pin post"
msgstr "ناتوان در سنجاق کردن فرسته"

#: src/components/status.jsx:1322
msgid "Unpin from profile"
msgstr "برداشتن سنجاق "

#: src/components/status.jsx:1329
msgid "Pin to profile"
msgstr "سنجاق کردن به نمایه"

#: src/components/status.jsx:1358
msgid "Delete this post?"
msgstr "این فرسته را حذف میکنید؟"

#: src/components/status.jsx:1374
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1377
msgid "Unable to delete post"
msgstr ""

#: src/components/status.jsx:1405
msgid "Report post…"
msgstr "گزارش دادن فرسته…"

#. placeholder {6}: username || acct
#: src/components/status.jsx:1475
msgid "Unboosted @{6}'s post"
msgstr ""

#. placeholder {7}: username || acct
#: src/components/status.jsx:1476
msgid "Boosted @{7}'s post"
msgstr ""

#: src/components/status.jsx:1761
#: src/components/status.jsx:1797
#: src/components/status.jsx:2485
msgid "Liked"
msgstr ""

#: src/components/status.jsx:1794
#: src/components/status.jsx:2472
msgid "Boosted"
msgstr ""

#: src/components/status.jsx:1804
#: src/components/status.jsx:2497
msgid "Bookmarked"
msgstr ""

#: src/components/status.jsx:1808
msgid "Pinned"
msgstr ""

#: src/components/status.jsx:1854
#: src/components/status.jsx:2311
msgid "Deleted"
msgstr ""

#: src/components/status.jsx:1895
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr ""

#. placeholder {0}: snapStates.statusThreadNumber[sKey] ? ` ${snapStates.statusThreadNumber[sKey]}/X` : ''
#: src/components/status.jsx:1985
msgid "Thread{0}"
msgstr ""

#: src/components/status.jsx:2061
#: src/components/status.jsx:2123
#: src/components/status.jsx:2208
msgid "Show less"
msgstr ""

#: src/components/status.jsx:2061
#: src/components/status.jsx:2123
msgid "Show content"
msgstr ""

#: src/components/status.jsx:2208
msgid "Show media"
msgstr ""

#: src/components/status.jsx:2345
msgid "Edited"
msgstr ""

#: src/components/status.jsx:2422
msgid "Comments"
msgstr ""

#. More from [Author]
#: src/components/status.jsx:2723
msgid "More from <0/>"
msgstr ""

#: src/components/status.jsx:3025
msgid "Edit History"
msgstr ""

#: src/components/status.jsx:3029
msgid "Failed to load history"
msgstr ""

#: src/components/status.jsx:3034
#: src/pages/annual-report.jsx:45
msgid "Loading…"
msgstr ""

#: src/components/status.jsx:3270
msgid "HTML Code"
msgstr ""

#: src/components/status.jsx:3287
msgid "HTML code copied"
msgstr ""

#: src/components/status.jsx:3290
msgid "Unable to copy HTML code"
msgstr ""

#: src/components/status.jsx:3302
msgid "Media attachments:"
msgstr ""

#: src/components/status.jsx:3324
msgid "Account Emojis:"
msgstr ""

#: src/components/status.jsx:3355
#: src/components/status.jsx:3400
msgid "static URL"
msgstr ""

#: src/components/status.jsx:3369
msgid "Emojis:"
msgstr ""

#: src/components/status.jsx:3414
msgid "Notes:"
msgstr ""

#: src/components/status.jsx:3418
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr ""

#: src/components/status.jsx:3424
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/status.jsx:3429
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/status.jsx:3435
msgid "Post could be edited or deleted later."
msgstr "فرسته بعدا میتواند ویرایش یا حذف شود."

#: src/components/status.jsx:3441
msgid "Preview"
msgstr "پیش‌نمایش"

#: src/components/status.jsx:3450
msgid "Note: This preview is lightly styled."
msgstr "نکته: این پیش‌نمایش بصورت طراحی سبک است."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3694
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> تقویت‌شده"

#: src/components/timeline.jsx:455
#: src/pages/settings.jsx:1171
msgid "New posts"
msgstr "فرسته‌های جدید"

#: src/components/timeline.jsx:556
#: src/pages/home.jsx:214
#: src/pages/notifications.jsx:871
#: src/pages/status.jsx:990
#: src/pages/status.jsx:1363
msgid "Try again"
msgstr "تلاش مجدد"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:591
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr ""

#: src/components/timeline.jsx:596
msgid "Pinned posts"
msgstr ""

#: src/components/timeline.jsx:951
#: src/components/timeline.jsx:958
#: src/pages/catchup.jsx:1894
msgid "Thread"
msgstr "رشته"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:973
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>پالایش‌شده</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:172
msgid "Auto-translated from {sourceLangText}"
msgstr "ترجمهٔ خودکار از {sourceLangText}"

#: src/components/translation-block.jsx:210
msgid "Translating…"
msgstr "درحال ترجمه…"

#: src/components/translation-block.jsx:213
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "ترجمه از {sourceLangText} (تشخیص خودکار)"

#: src/components/translation-block.jsx:214
msgid "Translate from {sourceLangText}"
msgstr "ترجمه از {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:242
msgid "Auto ({0})"
msgstr "خودکار ({0})"

#: src/components/translation-block.jsx:255
msgid "Failed to translate"
msgstr "شکست در ترجمه"

#: src/compose.jsx:33
msgid "Editing source status"
msgstr "ویرایش وضعیت منبع"

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:35
msgid "Replying to @{0}"
msgstr "درحال پاسخ دادن به @{0}"

#: src/compose.jsx:63
msgid "You may close this page now."
msgstr "احتمالا باید این صفحه را الآن ببندید."

#: src/compose.jsx:71
msgid "Close window"
msgstr "بستن پنجره"

#: src/compose.jsx:87
msgid "Login required."
msgstr "نیاز به ورود."

#: src/compose.jsx:91
#: src/pages/annual-report.jsx:164
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:271
msgid "Go home"
msgstr "رفتن به خانه"

#: src/pages/account-statuses.jsx:232
msgid "Account posts"
msgstr "فرسته‌های حساب کاربری"

#: src/pages/account-statuses.jsx:239
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ پاسخ‌ها)"

#: src/pages/account-statuses.jsx:241
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- تقویت‌ها)"

#: src/pages/account-statuses.jsx:243
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:245
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (رسانه)"

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:316
msgid "Clear filters"
msgstr "پاک کردن پالایه‌ها"

#: src/pages/account-statuses.jsx:319
msgid "Clear"
msgstr "پاک کردن"

#: src/pages/account-statuses.jsx:333
msgid "Showing post with replies"
msgstr "نمایش فرسته با پاسخ‌ها"

#: src/pages/account-statuses.jsx:338
msgid "+ Replies"
msgstr "+ پاسخ‌ها"

#: src/pages/account-statuses.jsx:344
msgid "Showing posts without boosts"
msgstr "نمایش فرسته‌ها بدون تقویت‌ها"

#: src/pages/account-statuses.jsx:349
msgid "- Boosts"
msgstr "- تقویت‌ها"

#: src/pages/account-statuses.jsx:355
msgid "Showing posts with media"
msgstr "نمایش فرسته‌های دارای رسانه"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:372
msgid "Showing posts tagged with #{0}"
msgstr "نمایش فرسته‌هایی که با #{0} برچسب‌گذاری شده‌اند"

#. placeholder {1}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:411
msgid "Showing posts in {1}"
msgstr ""

#: src/pages/account-statuses.jsx:500
msgid "Nothing to see here yet."
msgstr "اینجا چیزی برای دیدن نیست."

#: src/pages/account-statuses.jsx:501
#: src/pages/public.jsx:98
#: src/pages/trending.jsx:450
msgid "Unable to load posts"
msgstr "ناتوان در بارگذاری فرسته‌ها"

#: src/pages/account-statuses.jsx:542
#: src/pages/account-statuses.jsx:572
msgid "Unable to fetch account info"
msgstr ""

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:549
msgid "Switch to account's instance {0}"
msgstr "انتقال به نمونهٔ حساب کاربری {0}"

#: src/pages/account-statuses.jsx:579
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "انتقال به نمونهٔ من (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:641
msgid "Month"
msgstr "ماه"

#: src/pages/accounts.jsx:56
msgid "Current"
msgstr "کنونی"

#: src/pages/accounts.jsx:102
msgid "Default"
msgstr "پیش‌گزیده"

#: src/pages/accounts.jsx:124
msgid "Switch to this account"
msgstr "تعویض کردن به این حساب کاربری"

#: src/pages/accounts.jsx:133
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:147
msgid "View profile…"
msgstr "نمایش نمایه…"

#: src/pages/accounts.jsx:164
msgid "Set as default"
msgstr "تنظیم به عنوان پیش‌گزیده"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:174
msgid "Log out <0>@{0}</0>?"
msgstr "از <0>@{0}</0> خارج میشوید؟"

#: src/pages/accounts.jsx:197
msgid "Log out…"
msgstr "خروج…"

#: src/pages/accounts.jsx:210
msgid "Add an existing account"
msgstr "افزودن یک حساب کاربری موجود"

#: src/pages/accounts.jsx:217
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "No bookmarks yet. Go bookmark something!"
msgstr "هنوز نشانکی نیست. برو چیزهایی را نشانک‌گذاری کن!"

#: src/pages/bookmarks.jsx:27
msgid "Unable to load bookmarks."
msgstr "ناتوان در بارگذاری نشانک‌ها."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "۱ ساعت گذشته"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "۲ ساعت گذشته"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "۳ ساعت گذشته"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "۴ ساعت گذشته"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "۵ ساعت گذشته"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "۶ ساعت گذشته"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "۷ ساعت گذشته"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "۸ ساعت گذشته"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "۹ ساعت گذشته"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "۱۰ ساعت گذشته"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "۱۱ ساعت گذشته"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "۱۲ ساعت گذشته"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr ""

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "برچسب‌های پی‌گرفته‌شده"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "گروه‌ها"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "نمایش دادن {selectedFilterCategory, select, all {همهٔ فرسته‌ها} original {فرسته‌های اصلی} replies {پاسخ‌ها} boosts {تقویت‌ها} followedTags {برچسب‌های پیگرفته} groups {گروه‌ها} filtered {فرسته‌های پالایش‌شده}}، {sortBy, select,createdAt {{sortOrder, select, asc {قدیمی‌ترین} desc {آخرین}}} reblogsCount {{sortOrder, select, asc {کمترین تقویت‌ها} desc {بیشترین تقویت‌ها}}} favouritesCount {{sortOrder, select, asc {کمترین پسندیده‌ها} desc {بیشترین پسندیده‌ها}}} repliesCount {{sortOrder, select, asc {کمترین پاسخ‌ها} desc {بیشترین پاسخ‌ها}}} density {{sortOrder, select, asc {کمترین تراکم} desc {بیشترین تراکم}}}} اولین{groupBy, select, account {، گروه‌بندی‌شده توسط نویسنده‌ها} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "راهنما"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "اين چيست؟"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr ""

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr ""

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr ""

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr ""

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "تمام فرسته‌های… را به من نشان بده"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "تا بیشترین"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr ""

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr ""

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "نکته: نمونهٔ شما فقط میتواند حداکثر ۸۰۰ فرسته بدون توجه به زمان در خط زمانی نمایش دهد. میتواند کمتر یا بیشتر باشد."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "قبلا…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural,one {# فرسته} other {# فرسته‌ها}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr ""

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr ""

#. placeholder {1}: pc.id
#: src/pages/catchup.jsx:1069
msgid "Catch-up {1} removed"
msgstr ""

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr ""

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr ""

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "این کمی زمانبر است."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "تنظیم مجدد پالایه‌ها"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr ""

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "همرسانی‌شده توسط {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:148
#: src/pages/search.jsx:313
msgid "All"
msgstr "همه"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural,one {# نویسنده} other {# نویسنده‌ها}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "مرتب‌سازی"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "تاریخ"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "تراکم"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "نویسنده‌ها"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "هیچ‌کدام"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "نمایش همهٔ نویسنده‌ها"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "نیازی نیست همه چیز را بخوانید."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "کافیست."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "برگشتن به بالا"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "پیوندهایی که توسط پی‌گرفته‌ها همرسانی شده‌اند، مرتب‌شده طبق شمارش همرسانی‌شده، تقویت‌ها و برگزیده‌ها."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "مرتب‌سازی: تراکم"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "فرسته‌ها با تراکم یا عمق اطلاعات مرتب‌شده‌اند. فرسته‌های کوتاه‌تر «سبک‌تر» هستند درحالیکه فرسته‌های طولانی‌تر «سنگین‌تر» هستند. فرسته‌هایی با تصاویر از فرسته‌های بدون تصویر «سنگین‌تر» هستند."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "گروه: نویسندگان"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "فرسته‌ها طبق نویسنده‌ها دسته‌بندی شده‌اند، طبق فرسته بر حسب نویسنده مرتب شده‌اند."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "نویسندهٔ پسین"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "نویسندهٔ پیشین"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "پیمایش به بالا"

#. placeholder {0}: filterInfo.titlesStr
#: src/pages/catchup.jsx:1876
msgid "Filtered: {0}"
msgstr "پالایش‌شده: {0}"

#: src/pages/favourites.jsx:26
msgid "No likes yet. Go like something!"
msgstr ""

#: src/pages/favourites.jsx:27
msgid "Unable to load likes."
msgstr "ناتوان در بارگذاری برگزیده‌ها."

#: src/pages/filters.jsx:22
msgid "Home and lists"
msgstr "خانه و سیاهه‌ها"

#: src/pages/filters.jsx:24
msgid "Public timelines"
msgstr "خط زمانی همگانی"

#: src/pages/filters.jsx:25
msgid "Conversations"
msgstr "گفتگوها"

#: src/pages/filters.jsx:26
msgid "Profiles"
msgstr "نمایه‌ها"

#: src/pages/filters.jsx:41
msgid "Never"
msgstr "هرگز"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "پالایهٔ جدید"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural,one {# پالایه} other {# پالایه‌ها}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "ناتوان در بارگذاری پالایه‌ها."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "هنوز پالایه‌ای نیست."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "اصافه کردن پالایه"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "ویرایش پالایه"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "ناتوان در ویرایش پالایه"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "ناتوان در ایحاد پالایه"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "عنوان"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "تمام واژه"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "کلیدواژهای نیست. یکی اضافه کنید."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "افزودن کلیدواژه"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr ""

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr ""

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr ""

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr ""

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "این پالایه را حذف میکنید؟"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr ""

#: src/pages/filters.jsx:609
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:611
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:615
msgid "Never expires"
msgstr "هرگز منقضی نمیشود"

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# برچسب} other {# برچسب‌ها}}"

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "ناتوان در بارگذاری برچسب‌های پی‌گرفته."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "هنوز برچسبی پی‌گرفته نشده."

#: src/pages/following.jsx:144
msgid "Nothing to see here."
msgstr "اینجا چیزی برای دیدن وجود ندارد."

#: src/pages/following.jsx:145
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "ناتوان در بارگذاری فرسته‌ها."

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (فقط رسانه) در {instance}"

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} در {instance}"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (فقط رسانه)"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:182
msgid "No one has posted anything with this tag yet."
msgstr "هنوز کسی با این برچسب چیزی نفرستاده است."

#: src/pages/hashtag.jsx:183
msgid "Unable to load posts with this tag"
msgstr "ناتوان در بارگذاری فرسته‌ها با این برچسب"

#: src/pages/hashtag.jsx:209
msgid "Unfollow #{hashtag}?"
msgstr ""

#: src/pages/hashtag.jsx:224
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} ناپی‌گرفته شد"

#: src/pages/hashtag.jsx:239
msgid "Followed #{hashtag}"
msgstr "#{hashtag} پی‌گرفته شد"

#: src/pages/hashtag.jsx:255
msgid "Following…"
msgstr "درحال پی‌گیری…"

#: src/pages/hashtag.jsx:283
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:297
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:306
#: src/pages/hashtag.jsx:322
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:329
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:394
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {بیشترین # برچسب‌ها}}"

#: src/pages/hashtag.jsx:397
msgid "Add hashtag"
msgstr "افزودن برچسب"

#: src/pages/hashtag.jsx:429
msgid "Remove hashtag"
msgstr "حذف کردن برچسب"

#: src/pages/hashtag.jsx:443
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:472
msgid "This shortcut already exists"
msgstr "این میانبر درحال حاضر موجود است"

#: src/pages/hashtag.jsx:475
msgid "Hashtag shortcut added"
msgstr "میانبر برچسب اضافه شد"

#: src/pages/hashtag.jsx:481
msgid "Add to Shortcuts"
msgstr "افزودن به میانبرها"

#: src/pages/hashtag.jsx:487
#: src/pages/public.jsx:140
#: src/pages/trending.jsx:479
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "یک نمونهٔ جدید وارد کنید مثل \"mastodon.social\""

#: src/pages/hashtag.jsx:490
#: src/pages/public.jsx:143
#: src/pages/trending.jsx:482
msgid "Invalid instance"
msgstr "نمونهٔ نامعتبر"

#: src/pages/hashtag.jsx:504
#: src/pages/public.jsx:157
#: src/pages/trending.jsx:494
msgid "Go to another instance…"
msgstr "رفتن به یک نمونهٔ دیگر…"

#: src/pages/hashtag.jsx:517
#: src/pages/public.jsx:170
#: src/pages/trending.jsx:505
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "رفتن به نمونهٔ من (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:210
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:230
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>جدید</0> <1>درخواست‌های پی‌گیری</1>"

#: src/pages/home.jsx:236
msgid "See all"
msgstr "دیدن همه"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr "هنوز چیزی نیست."

#: src/pages/list.jsx:177
#: src/pages/list.jsx:281
msgid "Manage members"
msgstr "مدیریت کردن اعضا"

#. placeholder {0}: account.username
#: src/pages/list.jsx:316
msgid "Remove <0>@{0}</0> from list?"
msgstr "<0>@{0}</0> را از سیاهه حذف میکنید؟"

#: src/pages/list.jsx:362
msgid "Remove…"
msgstr "حذف کردن…"

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:94
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# سیاهه} other {# سیاهه‌ها}}"

#: src/pages/lists.jsx:109
msgid "No lists yet."
msgstr "هنوز سیاهه‌ای نیست."

#: src/pages/login.jsx:110
#: src/pages/login.jsx:123
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "instance domain"
msgstr ""

#: src/pages/login.jsx:233
msgid "e.g. “mastodon.social”"
msgstr "مثلا \"mastodon.social\""

#: src/pages/login.jsx:244
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:256
msgid "Continue with {selectedInstanceText}"
msgstr "ادامه دادن با {selectedInstanceText}"

#: src/pages/login.jsx:257
msgid "Continue"
msgstr "ادامه"

#: src/pages/login.jsx:265
msgid "Don't have an account? Create one!"
msgstr "حساب کاربری ندارید؟ یکی بسازید!"

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr "اشاره‌های خصوصی"

#: src/pages/mentions.jsx:160
msgid "Private"
msgstr "خصوصی"

#: src/pages/mentions.jsx:170
msgid "No one mentioned you :("
msgstr "کسی به شما اشاره نکرده :("

#: src/pages/mentions.jsx:171
msgid "Unable to load mentions."
msgstr ""

#: src/pages/notifications.jsx:104
msgid "You don't follow"
msgstr "شما پی نمیگیرید"

#: src/pages/notifications.jsx:105
msgid "Who don't follow you"
msgstr "کسی که شما را دنبال نمیکند"

#: src/pages/notifications.jsx:106
msgid "With a new account"
msgstr "با یک حساب کاربری جدید"

#: src/pages/notifications.jsx:107
msgid "Who unsolicitedly private mention you"
msgstr "کسی که بصورت ناخواسته به شما اشارهٔ خصوصی کرده"

#: src/pages/notifications.jsx:108
msgid "Who are limited by server moderators"
msgstr "کسی که توسط ناظم‌های کارساز محدود شده است"

#: src/pages/notifications.jsx:578
#: src/pages/notifications.jsx:919
msgid "Notifications settings"
msgstr "تنظیمات آگهی‌ها"

#: src/pages/notifications.jsx:596
msgid "New notifications"
msgstr ""

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:607
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:654
#: src/pages/settings.jsx:1159
msgid "Follow requests"
msgstr "درخواست‌های پی‌گیری"

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:659
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# درخواست پی‌گیری} other {# درخواست پیگیری}}"

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:714
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {آگاهی‌های پالایش‌شده از شخص #} other {آگاهی‌های پالایش‌شده از شخص #}}"

#: src/pages/notifications.jsx:787
msgid "Only mentions"
msgstr "فقط اشاره‌ها"

#: src/pages/notifications.jsx:791
msgid "Today"
msgstr "امروز"

#: src/pages/notifications.jsx:796
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:819
msgid "Yesterday"
msgstr "دیروز"

#: src/pages/notifications.jsx:867
msgid "Unable to load notifications"
msgstr "ناتوان در بارگذاری آگاهی‌ها"

#: src/pages/notifications.jsx:946
msgid "Notifications settings updated"
msgstr "تنظیمات آگاهی‌ها بارگذاری شدند"

#: src/pages/notifications.jsx:954
msgid "Filter out notifications from people:"
msgstr "پالایش کردن آگاهی‌ها از افراد:"

#: src/pages/notifications.jsx:968
msgid "Filter"
msgstr "پالایش کردن"

#: src/pages/notifications.jsx:971
msgid "Ignore"
msgstr "نادیده گرفتن"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1044
msgid "Updated <0>{0}</0>"
msgstr "بروزشده <0>{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1112
msgid "View notifications from <0>@{0}</0>"
msgstr "نمایش آگاهی‌ها از <0>@{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1133
msgid "Notifications from <0>@{0}</0>"
msgstr "آگاهی‌ها از <0>@{0}</0>"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1201
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "آگاهی‌ها از @{0} از الآن پالایش نخواهند شد."

#: src/pages/notifications.jsx:1206
msgid "Unable to accept notification request"
msgstr "ناتوان در قبول کردن درخواست آگاهی"

#: src/pages/notifications.jsx:1211
msgid "Allow"
msgstr "اجازه دادن"

#. placeholder {1}: request.account.username
#: src/pages/notifications.jsx:1231
msgid "Notifications from @{1} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1236
msgid "Unable to dismiss notification request"
msgstr "ناتوان در رد کردن درخواست آگاهی"

#: src/pages/notifications.jsx:1241
msgid "Dismiss"
msgstr "رد کردن"

#: src/pages/notifications.jsx:1256
msgid "Dismissed"
msgstr "رد شد"

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr "خط زمانی محلی ({instance})"

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr "خط زمانی نامتمرکز ({instance})"

#: src/pages/public.jsx:91
msgid "Local timeline"
msgstr "خط زمانی محلی"

#: src/pages/public.jsx:91
msgid "Federated timeline"
msgstr "خط زمانی نامتمرکز"

#: src/pages/public.jsx:97
msgid "No one has posted anything yet."
msgstr "هنوز کسی چیزی ارسال نکرده است."

#: src/pages/public.jsx:124
msgid "Switch to Federated"
msgstr "تعویض کردن به نامتمرکز"

#: src/pages/public.jsx:131
msgid "Switch to Local"
msgstr "تعویض کردن به محلی"

#: src/pages/scheduled-posts.jsx:108
msgid "No scheduled posts."
msgstr ""

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:205
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr ""

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:261
msgid "Scheduled <0><1/></0>"
msgstr ""

#: src/pages/scheduled-posts.jsx:306
msgid "Scheduled post rescheduled"
msgstr ""

#: src/pages/scheduled-posts.jsx:313
msgid "Failed to reschedule post"
msgstr ""

#: src/pages/scheduled-posts.jsx:336
msgid "Reschedule"
msgstr ""

#: src/pages/scheduled-posts.jsx:342
msgid "Delete scheduled post?"
msgstr ""

#: src/pages/scheduled-posts.jsx:350
msgid "Scheduled post deleted"
msgstr ""

#: src/pages/scheduled-posts.jsx:357
msgid "Failed to delete scheduled post"
msgstr ""

#: src/pages/search.jsx:50
msgid "Search: {q} (Posts)"
msgstr "جستجو: {q} (فرسته‌ها)"

#: src/pages/search.jsx:53
msgid "Search: {q} (Accounts)"
msgstr "جستجو: {q} (حساب‌های کاربری)"

#: src/pages/search.jsx:56
msgid "Search: {q} (Hashtags)"
msgstr "جستجو: {q} (برچسب‌ها)"

#: src/pages/search.jsx:59
msgid "Search: {q}"
msgstr "جستجو: {q}"

#: src/pages/search.jsx:323
#: src/pages/search.jsx:405
msgid "Hashtags"
msgstr "برچسب‌ها"

#: src/pages/search.jsx:355
#: src/pages/search.jsx:409
#: src/pages/search.jsx:479
msgid "See more"
msgstr "بیشتر ببینید"

#: src/pages/search.jsx:381
msgid "See more accounts"
msgstr "حساب‌های کاربری بیشتری را ببینید"

#: src/pages/search.jsx:395
msgid "No accounts found."
msgstr "حسابی یافت نشد."

#: src/pages/search.jsx:451
msgid "See more hashtags"
msgstr "دیدن برچسب‌های بیشتر"

#: src/pages/search.jsx:465
msgid "No hashtags found."
msgstr "برچسبی پیدا نشد."

#: src/pages/search.jsx:509
msgid "See more posts"
msgstr "دیدن فرسته‌های بیشتر"

#: src/pages/search.jsx:523
msgid "No posts found."
msgstr "فرسته‌ای پیدا نشد."

#: src/pages/search.jsx:567
msgid "Enter your search term or paste a URL above to get started."
msgstr "مورد جستجوی خود را وارد کنید یا "

#: src/pages/settings.jsx:83
msgid "Settings"
msgstr "تنظیمات"

#: src/pages/settings.jsx:92
msgid "Appearance"
msgstr "ظاهر"

#: src/pages/settings.jsx:168
msgid "Light"
msgstr "روشن"

#: src/pages/settings.jsx:179
msgid "Dark"
msgstr "تاریک"

#: src/pages/settings.jsx:192
msgid "Auto"
msgstr "خودکار"

#: src/pages/settings.jsx:202
msgid "Text size"
msgstr "اندازهٔ نوشته"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:207
#: src/pages/settings.jsx:232
msgid "A"
msgstr "الف"

#: src/pages/settings.jsx:246
msgid "Display language"
msgstr "نمایش زبان"

#: src/pages/settings.jsx:255
msgid "Volunteer translations"
msgstr "ترجمه‌های داوطلبانه"

#: src/pages/settings.jsx:266
msgid "Posting"
msgstr "درحال ارسال"

#: src/pages/settings.jsx:273
msgid "Default visibility"
msgstr "دید پیش‌گزیده"

#: src/pages/settings.jsx:274
#: src/pages/settings.jsx:320
msgid "Synced"
msgstr "همگام‌سازی شد"

#: src/pages/settings.jsx:299
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:322
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "با تنظیمات کارساز نمونهٔ شما همگام‌سازی شد. <0> برای تنظیمات بیشتر به نمونهٔ خود ({instance}) بروید.</0>"

#: src/pages/settings.jsx:337
msgid "Experiments"
msgstr "آزمایش‌ها"

#: src/pages/settings.jsx:350
msgid "Auto refresh timeline posts"
msgstr "بارگذاری مجدد خودکار فرسته‌های خط زمانی"

#: src/pages/settings.jsx:362
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:378
msgid "Post translation"
msgstr "ترجمهٔ فرسته"

#: src/pages/settings.jsx:389
msgid "Translate to "
msgstr ""

#: src/pages/settings.jsx:400
msgid "System language ({systemTargetLanguageText})"
msgstr "زبان سامانه ({systemTargetLanguageText})"

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages.length
#: src/pages/settings.jsx:426
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {مخفی کردن دکمهٔ «ترجمه» برای:} other {مخفی کردن دکمهٔ «ترجمه» برای (#):}}"

#: src/pages/settings.jsx:480
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "نکته: این قابلیت از خدمات ترجمهٔ خارجی، قدرت گرفته از <0>Lingva API</0> و <1>Lingva Translate</1>."

#: src/pages/settings.jsx:514
msgid "Auto inline translation"
msgstr "ترجمهٔ خودکار درخط"

#: src/pages/settings.jsx:518
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "بصورت خودکار ترجمه را برای فرسته‌ها در خط زمانی نمایش میدهد. فقط برای فرسته‌های <0>کوتاه</0> بدون هشدار محتوا، رسانه یا نظرسنجی کار میکند."

#: src/pages/settings.jsx:538
msgid "GIF Picker for composer"
msgstr "انتخاب‌کنندهٔ جیف برای نویسنده"

#: src/pages/settings.jsx:542
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "نکته: این قابلیت از یک خدمت خراجی جستجوی جیف، قدرت‌گرفته از <0>جیفی</0>، استفاده میکند. رده‌بندی سنی عمومی (مناسب برای مشاهدهٔ همهٔ سنین)، ویژگی‌های دنبال‌کننده سلب شده‌اند، اطلاعات درخواست‌کننده از درخواست‌ها حذف شده‌اند، ولی درخواست جستجو و نشانی آی‌پی همچنان به کارساز آنها خواهند رسید."

#: src/pages/settings.jsx:571
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:576
msgid "Only for new images while composing new posts."
msgstr "فقط برای تصاویر جدید در زمان نوشتن فرسته‌های جدید."

#: src/pages/settings.jsx:583
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "نکته: این قابلیت از یک خدمت هوش مصنوعی خارجی، قدرت گرفته از <0>img-alt-api</0>، استفاده میکند. شاید خوب کار نکند. فقط برای تصاویر و به زبان انگلیسی است."

#: src/pages/settings.jsx:609
msgid "Server-side grouped notifications"
msgstr "آگهی‌های گروه‌بندی‌شدهٔ سمت کارساز"

#: src/pages/settings.jsx:613
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:634
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "ورود/صدور «ابری» برای تنظیمات میانبرها"

#: src/pages/settings.jsx:639
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ بسیار آزمایشی.<0/>در یادداشت‌های نمایهٔ خود شما ذخیره میشود. یادداشت‌های (خصوصی) نمایه در اصل برای بقیهٔ نمایه‌ها استفاده میشوند، و برای نمایهٔ خود پنهان هستند."

#: src/pages/settings.jsx:650
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "نکته: این قابلیت از API کارساز نمونه‌ای که اکنون وارد شده‌اید استفاده میکند."

#: src/pages/settings.jsx:667
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "حالت پوشش<0>(<1>متن</1> ← <2>████</2>)</0>"

#: src/pages/settings.jsx:676
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:701
msgid "About"
msgstr "درباره"

#: src/pages/settings.jsx:740
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>ساخته‌شده</0> توسط <1>@cheeaun</1>"

#: src/pages/settings.jsx:769
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:777
msgid "Donate"
msgstr ""

#: src/pages/settings.jsx:789
msgid "Privacy Policy"
msgstr ""

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:796
msgid "<0>Site:</0> {0}"
msgstr "<0>وبگاه:</0> {0}"

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:803
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>نگارش:</0> <1/> {0}"

#: src/pages/settings.jsx:818
msgid "Version string copied"
msgstr "رشتهٔ نگارش رونوشت شد"

#: src/pages/settings.jsx:821
msgid "Unable to copy version string"
msgstr "ناتوان در رونوشت رشتهٔ نگارش"

#: src/pages/settings.jsx:1056
#: src/pages/settings.jsx:1061
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1067
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1074
msgid "Push Notifications (beta)"
msgstr "آگاهی ارسالی (بتا)"

#: src/pages/settings.jsx:1096
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "آگاهی‌های ارسالی مسدود شده‌اند. لطفا آنها را در تنظیمات مرورگر خود فعال کنید."

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1105
msgid "Allow from <0>{0}</0>"
msgstr "اجازه دادن از <0>{0}</0>"

#: src/pages/settings.jsx:1114
msgid "anyone"
msgstr "هرکس"

#: src/pages/settings.jsx:1118
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:1122
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1155
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1163
msgid "Polls"
msgstr ""

#: src/pages/settings.jsx:1167
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1188
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "اجازهٔ ارسال از زمان آخرین ورود شما داده نشده. شما باید دوباره <0><1>وارد شوید</1> و اجازهٔ ارسال را بدهید</0>."

#: src/pages/settings.jsx:1204
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "نکته: آگاهی‌های ارسالی فقط برای <0>یک حساب کاربری</0> کار میکنند."

#. js-lingui-explicit-id
#: src/pages/status.jsx:599
#: src/pages/status.jsx:1133
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:824
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:844
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:872
msgid "Error: {e}"
msgstr ""

#: src/pages/status.jsx:879
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:981
msgid "Unable to load replies."
msgstr ""

#: src/pages/status.jsx:1093
msgid "Back"
msgstr ""

#: src/pages/status.jsx:1124
msgid "Go to main post"
msgstr ""

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1147
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1190
#: src/pages/status.jsx:1253
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1254
msgid "Switch to Full view"
msgstr "تعویض به حالت نمایش کامل"

#: src/pages/status.jsx:1272
msgid "Show all sensitive content"
msgstr "نمایش همهٔ محتوای حساس"

#: src/pages/status.jsx:1277
msgid "Experimental"
msgstr "آزمایشی"

#: src/pages/status.jsx:1286
msgid "Unable to switch"
msgstr ""

#. placeholder {1}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1293
msgid "Switch to post's instance ({1})"
msgstr ""

#: src/pages/status.jsx:1296
msgid "Switch to post's instance"
msgstr "تعویض به نمونهٔ فرسته"

#: src/pages/status.jsx:1354
msgid "Unable to load post"
msgstr ""

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1490
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1508
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1530
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:72
msgid "Trending ({instance})"
msgstr ""

#: src/pages/trending.jsx:229
msgid "Trending News"
msgstr ""

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:348
msgid "By {0}"
msgstr ""

#: src/pages/trending.jsx:409
msgid "Back to showing trending posts"
msgstr ""

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:414
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:426
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:449
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>ساخته‌شده</0> توسط <1>@cheeaun</1>. <2>حریم خصوصی</2>."

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:142
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:146
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:149
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:157
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:161
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:164
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

